<template>
  <el-drawer destroy-on-close :visible.sync="vis" :close-on-click-modal="false" id="vehicleDetails">
    <!-- <el-tabs type="card" v-model="tabAction">
      <el-tab-pane label="工单详情" name="order"> -->
    <el-button
        v-if="mixinUserInfo.platformType === 2 && order.status === 45 && (btnPreFn('order_station_print_single',false) || btnPreFn('order_station_print_multiple',false))"
        @click="printDetails" type="primary">打印
    </el-button>
    <div>
      <div id="printForm">
        <div class="formTitle">
          {{ order.schedulingNo }} /
          <el-tag size="small" :type="order.status | filterConst('SHIFTORDERSTATUS2', 'type')">{{ order.status | filterConst("SHIFTORDERSTATUS2") }}</el-tag>
        </div>
        <div class="box">
          <div class="item" style="width: 66%">
            <span class="title">线路名称</span>
            <span class="value">{{ order.startStationName }} - {{ order.endStationName }}</span>
          </div>
          <div class="item">
            <span class="title">班次</span>
            <span class="value">{{ order.schedulingTime | filterTime("MM-DD") }}
          {{ order.startLineTime }}
            </span>
          </div>


          <div class="item">
            <span class="title">开始时间</span>
            <span class="value">{{ order.serviceTime | filterTime }}</span>
          </div>
          <div class="item">
            <span class="title">完成/取消时间</span>
            <span class="value">{{ order.finishTime | filterTime }}</span>
          </div>

          <div class="item">
            <span class="title">订单金额</span>
            <span class="value" style="color: #ff9900; font-weight: bold">￥{{ order.realTotalFee }}</span>
          </div>
          <div class="item" v-if="loadData.isShow == '1' && order.status === 45">
            <span class="title">车站劳务费</span>
            <span class="value" style="color: #ff9900; font-weight: bold">￥{{ order.stationServiceFee }}</span>
          </div>
          <div class="item" v-if="loadData.isShow == '1' && order.status === 45">
            <span class="title">税费</span>
            <span class="value" style="color: #ff9900; font-weight: bold">￥{{ order.taxesFee }}</span>
          </div>
          <div class="item" v-if="loadData.isShow == '1' && order.status === 45">
            <span class="title">车站站务费</span>
            <span class="value" style="color: #ff9900; font-weight: bold">￥{{ order.stationChargeFee }}</span>
          </div>


          <div class="item">
            <span class="title">车辆信息</span>
            <span v-if="order.licenseNo" :style="getPlateStyle(order.licenseNo)">{{ formatPlateNumber(order.licenseNo) }}</span>
            <span v-else class="value">-</span>
          </div>
          <div class="item">
            <span class="title">司机姓名</span>
            <span class="value">{{ order.driverName }}</span>
          </div>
          <div class="item">
            <span class="title">司机电话</span>
            <span class="value">{{ order.driverPhone }}</span>
          </div>
          <div class="item">
            <span class="title">乘车人数</span>
            <span class="value">{{ order.passengerAllNum }}人</span>
          </div>
        </div>
        <div class="formTitle" v-if="mixinUserInfo.platformType === 2">站点人数统计</div>
        <div v-if="mixinUserInfo.platformType === 2" class="flex-between" style="align-items: flex-start">
          <div style="width: 45%">
            <el-table
                :data="passengerData1"
                border
                style="width: 100%"
            >
              <el-table-column
                  prop="name"
                  label="上车站点">
              </el-table-column>
              <el-table-column
                  prop="passengerNum"
                  label="人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.passengerNum }}人</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div style="width: 45%">
            <el-table
                :data="passengerData2"
                border
                style="width: 100%">
              <el-table-column
                  prop="name"
                  label="下车站点">
              </el-table-column>
              <el-table-column
                  prop="passengerNum"
                  label="人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.passengerNum }}人</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>


      <div class="formTitle" style="margin-top: 20px">乘客订单</div>

      <el-table style="margin-bottom: 20px" border empty-text="暂无数据" :data="orderVoList" highlight-current-row>
        <el-table-column v-for="(item, index) in columns" :key="index"
                         :show-overflow-tooltip="mixinUserInfo.platformType !== 2" :prop="item.prop"
                         :label="item.label" :width="item.width">
          <template slot-scope="{ row }">
            <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
            <template v-else-if="item.prop === 'customerName'">
              <div v-for="(customer, index) in row.orderCustomerVoList" :key="index">
                {{ customer.customerName }} {{ customer.idCard || '' }} <span v-if="customer.cardType > 1">({{ customer.cardType | fliterCardType }})</span> {{ customer.customerPhone || '' }}
                {{ ['全票', '半价票', '免票(占座)', '免票(不占座)'][customer.ticketType - 1] }}
              </div>
            </template>
            <template v-else-if="item.prop === 'status'">
              <span v-if="row.status !== 45">{{ row.status | filterOrderSubStatus }}</span>
              <span v-if="row.status === 45">
              {{ row.loadType === 2 ? "未上车" : row.status | filterOrderSubStatus }}
            </span>
            </template>
            <template v-else-if="item.prop === 'realFee'">
              <template v-if="row.realFee || row.realFee === 0">
                <span class="util-money">￥{{ row.realFee }}</span>
                <span v-if="row.couponFee">(优惠券<span class="util-money-minus">-￥{{ row.couponFee }}</span>)</span>
              </template>
              <span v-if="!row.realFee && row.realFee !== 0">-</span>
            </template>
            <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
          </template>
        </el-table-column>
      </el-table>
      <!-- </el-tab-pane>
       <el-tab-pane label="地图查看" name="map">
          <el-button v-show="showDriver" @click="getDriverLocation" plain
            style="position: absolute; left: 34%; top: 2%; z-index: 999">查看司机实时位置</el-button>
          <el-table style="width: 30%; display: inline-block; vertical-align: top" border empty-text="暂无数据"
            :data="orderVoList" @row-click="rowClick" ref="mapTable" highlight-current-row>
            <el-table-column v-for="(item, index) in columnsMap" :key="index" show-overflow-tooltip :prop="item.prop"
              :label="item.label" :width="item.width">
              <template slot-scope="{ row }">
                <template v-if="item.prop === 'customerName'">{{
                  row.created +
                  " " +
                  row.customerPhone +
                  " " +
                  row.passengerNum +
                  "人"
                }}</template>
                <template v-else-if="item.prop === 'status'">
                  <span v-if="row.status !== 45">{{
                    row.status | filterOrderSubStatus
                  }}</span>
                  <span v-if="row.status === 45">
                    {{
                      row.loadType === 2
                      ? "未上车"
                      : row.status | filterOrderSubStatus
                    }}</span>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div id="order-map" style="display: inline-block"></div>
        </el-tab-pane>
      </el-tabs> -->


      <div id="printDiv" >

        <div class="printDiv-station" style="height: 14px;line-height:14px;margin-top: 113.4px;margin-left: 115px;">
          <span class="printDiv-station-one"
                style="font-size: 12px">{{ order.schedulingTime | filterTime2('YYYY-MM-DD') }}</span>
        </div>

        <div class="printDiv-station" style="height: 14px;line-height:14px;margin-top: 10px;margin-left: 115px;">
          <span class="printDiv-station-one" style="font-size: 12px">{{ order.schedulingTime | filterTime2('MM-DD') }} {{ order.startLineTime }}</span>
          <span class="printDiv-station-two" style="font-size: 12px;margin-left: 40px">{{
              order.startStationName
            }}-{{ order.endStationName }}</span>
        </div>

        <div class="printDiv-station" style="display: inline-block;height: 14px;margin-top: 10px;margin-left: 115px;font-size: 12px;vertical-align: top;">
          <span class="printDiv-station-one" style="width: 120px;height: 14px;display: inline-block;vertical-align: top">{{ detailOrder.companyName }}</span>
          <span class="printDiv-station-two" style="display: inline-block;font-size: 12px;vertical-align: top">{{ order.licenseNo }}</span>
        </div>


        <div  style="margin:20px 0 0 85px;height:250px;font-size: 12px">
          <div>
            <span style="width: 80px;display: inline-block">到站：</span>
            <span style="width: 140px;display: inline-block">单价：</span>
            <span style="width: 50px;display: inline-block">人数：</span>
            <span style="width: 70px;display: inline-block">小记：</span>
          </div>

          <div v-if="detailVos && detailVos.length">
            <div v-for="(item,index) in detailVos" :key="index">
              <span style="width: 80px;display: inline-block">{{item.addressName}}</span>
              <span style="width: 140px;display: inline-block"><span style="width: 55px;display: inline-block">{{item.orderFee}}元</span> <span >{{item.ticketType | filterConst('TICKETTYPE')}}</span></span>
              <span style="width: 50px;display: inline-block">{{item.passengerNum}}</span>
              <span style="width: 70px;display: inline-block">{{item.totalFee}}元</span>
            </div>
          </div>

        </div>

        <div  style="font-size: 12px;margin-left: 148px">
          <span style="display: inline-block;width: 120px">{{detailOrder.totalFeeStr}}</span>
          <span style="display: inline-block;width:80px">共计:{{detailOrder.totalPassengerNum}}</span>
          <span style="display: inline-block;">{{detailOrder.totalFee}}</span>
        </div>

        <div style="font-size: 12px;margin-left: 140px;margin-top: 40px">
          <span style="display: inline-block;width: 120px">{{mixinUserInfo.name}}</span>
          <span style="margin-left: 20px">{{new Date().getTime() | filterTime2('YYYY-MM-DD HH:mm')}}</span>
        </div>

      </div>
    </div>
  </el-drawer>
</template>

<script>
import AMap from "AMap";
import printJS from 'print-js'
import html2Canvas from "html2canvas";


export default {
  name: "vehicleDetails",
  props: {
    visible: {
      // 显隐
      default() {
        return false;
      },
    },
    order: {
      // 订单
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      tabAction: "order",
      map: null,
      vis: false,
      columns: [
        {prop: "orderNo", label: "订单号", width: 200},
        {prop: "status", label: "订单状态", width: 70},
        {prop: "created", label: "下单时间", width: 140},
        {prop: "customerName", label: "乘客信息"},
        {prop: "realFee", label: "实付金额", width: 70},
        {prop: "remark", label: "备注", width: 50},
      ],
      columnsMap: [
        {prop: "status", label: "订单状态"},
        {prop: "customerName", label: "乘客信息", width: 220},
      ],
      orderVoList: [],
      markerDriver: null,
      markerBegin: null,
      markerEnd: null,
      showDriver: false,
      driverLocation: null,
      checkRow: false,
      passengerData1: [],
      passengerData2: [],
      loadData: {
        isShow: '2'
      },
      detailVos: [],
      detailOrder: {}
    };
  },
  watch: {
    visible(val) {
      this.vis = val;
    },
    vis(val) {
      if (!val) {
        if (this.markerBegin) {
          this.markerBegin.setMap(null);
          this.markerEnd.setMap(null);
        }
        if (this.markerDriver) {
          this.markerDriver.setMap(null);
        }
        this.checkRow = false;
      } else if (this.tabAction == "map") {
        this.$nextTick(() => {
          this.rowClick(this.orderVoList[0]);
        });
      }
      this.$emit("update:visible", val);

      this.vis && this.getPassengerFn()

    },
    order: {
      handler(val) {
        if (val) {
          this.orderVoList = val.orderVoList;
          if (val.status == 40) {
            this.showDriver = true;
          } else {
            this.showDriver = false;
          }

          this.order.status === 45 && this.getInitShowFn()
        }
      },
      deep: true,
    },
    // tabAction(val) {
    //   if (val == "map") {
    //     if (!this.map) {
    //       this.initMap();
    //     }
    //     if (this.showDriver) {
    //       this.getDriverLocation();
    //     }
    //     if (!this.checkRow) {
    //       this.rowClick(this.orderVoList[0]);
    //     }
    //   }
    // },
  },
  methods: {
    async getInitShowFn() {
      const url = "/api/v1/manage/systems/station/settle/config"
      const {code, data} = await this.$axios.get(url, {
        organizationId: this.mixinUserInfo.organizationId
      })
      if (code === 1 && data) {
        this.loadData = {
          isShow: String(data.isShow)
        }
      }
    },
    async getPassengerFn() {
      let url = "/api/v1/manage/order/scheduling/station/passenger/" + this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.passengerData1 = data.data.filter((item) => item.type === 1)
        this.passengerData2 = data.data.filter((item) => item.type === 2)
      }
    },


    async printDetails() {
      const loading = this.$loading({
        lock: true,
        text: '加载中,请稍候',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const url = "/api/v1/manage/order/scheduling/station/print/" + this.order.id;
      const {data, code} = await this.$axios.get(url);
      loading.close()
      if (data && code == 1) {
        this.detailOrder = data
        this.detailVos = data.detailVos
        console.log(data);
        this.$nextTick(() => {
          const printContentHtml = document.getElementById("printDiv").innerHTML;
          const iframe = document.createElement("iframe");
          document.body.appendChild(iframe);
          iframe.contentDocument.write(printContentHtml);
          iframe.contentDocument.close();
          iframe.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 2000);
        })
      }

    },
    // 地图初始化
    initMap() {
      this.map = new AMap.Map("order-map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });
    },
    // 查看上下车位置
    lookLocation(row) {
      this.tabAction = "map";
      this.$nextTick(() => {
        this.rowClick(row);
      });
    },
    // 点击行加载标点
    async rowClick(row) {
      this.checkRow = true;
      this.$refs.mapTable.setCurrentRow(row);
      if (this.markerBegin) {
        this.markerBegin.setMap(null);
        this.markerEnd.setMap(null);
      }

      let begin = row.address[0];
      let end = row.address[1];
      let beginContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #4dace2;">
                                <div style="text-align:center;margin-bottom:5px;">${row.customerPhone}</div>
                                <div>上车地点：${begin.name}</div>
                            </div>`;
      let endContent = `<div  style="
                                padding: 10px;
                                justify-content: center; 
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #47c147;">
                                <div style="text-align:center;margin-bottom:5px;">${row.customerPhone}</div>
                                <div>下车地点：${end.name}</div>
                          </div>`;

      this.markerBegin = new AMap.Marker({
        position: new AMap.LngLat(begin.longitude, begin.latitude),
        icon: require("@/assets/img/markerBegin.png"),
        map: this.map,
      });
      this.markerBegin.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: beginContent,
        direction: "top",
      });

      this.markerEnd = new AMap.Marker({
        position: new AMap.LngLat(end.longitude, end.latitude),
        icon: require("@/assets/img/markerEnd.png"),
        map: this.map,
      });
      this.markerEnd.setLabel({
        offset: new AMap.Pixel(0, -6),
        content: endContent,
        direction: "top",
      });

      this.$nextTick(() => {
        this.map.setFitView();
      });
    },
    // 查看司机位置
    async getDriverLocation() {
      if (this.markerDriver) {
        this.markerDriver.setMap(null);
      }
      let url = "/api/V1/manage/order/scheduling/driver/location";
      let params = {
        driverId: this.order.driverId,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        if (data.data) {
          this.markerDriver = new AMap.Marker({
            position: new AMap.LngLat(
                data.data.location.longitude,
                data.data.location.latitude
            ),
            icon: require("@/assets/img/car.png"),
            map: this.map,
          });
          this.map.setCenter([
            data.data.location.longitude,
            data.data.location.latitude,
          ]);
        }
      }
    },
  },
};
</script>

<style lang="less">
#vehicleDetails {
  /deep/ .el-drawer {
    overflow: hidden;
    width: 70% !important;
  }

  .link {
    text-decoration: none;
  }

  #order-map {
    display: inline-block;
    vertical-align: top;
    width: 68%;
    margin-left: 2%;
    height: 830px;
  }

  .el-col {
    margin: 15px 0;
  }

  .box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    font-size: 14px;

    .item {
      width: 33%;
      margin: 15px 0;

      .title {
        display: inline-block;
        width: 100px;
        margin-right: 20px;
      }

      .value {
        color: #999;

        &:empty {
          &::after {
            content: "-";
          }
        }
      }
    }
  }

  /deep/ table {
    table-layout: fixed !important;
  }

  /deep/ .el-table__header-wrapper .el-table__header {
    width: 100% !important;
  }

  /deep/ .el-table__body-wrapper .el-table__body {
    width: 100% !important;
  }


}

#printDiv {
  position: fixed;
  top: -2000px;
  z-index: -100;

}


</style>
